"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var effects_1 = require("@ngrx/effects");
var store_1 = require("@ngrx/store");
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var Observable_1 = require("rxjs/Observable");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var noop_1 = require("rxjs/util/noop");
var kb_utilities_1 = require("../kb.utilities");
var group_serializer_1 = require("../serialization/group.serializer");
var kb_service_1 = require("../services/kb.service");
var kb_reducers_1 = require("./kb.reducers");
var logger = kb_utilities_1.createLogger('kb-effects');
var KbEffects = /** @class */ (function () {
    // endregion
    function KbEffects(actions, kbService, store) {
        var _this = this;
        this.actions = actions;
        this.kbService = kbService;
        this.store = store;
        // region categories
        this.loadCategories$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ALL)), operators_1.mergeMap(function (action) {
            return _this.kbService.loadCategories(_this.toPrefix(action)).pipe(operators_1.map(function (categories) {
                return skynet_store_kb_api_1.categoryStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_MANY_SUCCESS, categories);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.categoryStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, new skynet_store_utilities_1.StoreManagerError(err, '')));
            }));
        }));
        this.loadCategory$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ONE)), operators_1.mergeMap(function (action) {
            return _this.store
                .select(function (state) { return state.kb.categories[_this.toPrefix(action)]; })
                .pipe(operators_1.first(), operators_1.mergeMap(function (categories) {
                var category = skynet_store_utilities_1.notNil(categories)
                    ? categories.find(function (c) { return c.metaCategoryId.systemName === action.id; })
                    : undefined;
                if (skynet_store_utilities_1.notNil(category)) {
                    return of_1.of(skynet_store_kb_api_1.categoryStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_ONE_SUCCESS, category));
                }
                return _this.kbService
                    .loadCategory(action.id, _this.toPrefix(action))
                    .pipe(operators_1.map(function (c) {
                    return skynet_store_kb_api_1.categoryStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_ONE_SUCCESS, c);
                }), operators_1.catchError(function (err) {
                    return of_1.of(skynet_store_kb_api_1.categoryStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, new skynet_store_utilities_1.StoreManagerError(err, '')));
                }));
            }));
        }));
        this.createCategory$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.CREATE)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .createCategory(action.item, _this.toPrefix(action))
                .pipe(operators_1.map(function (category) {
                return skynet_store_kb_api_1.categoryStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS, category);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.categoryStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.CREATE_FAIL, new skynet_store_utilities_1.StoreManagerError(err, 'could not create category')));
            }));
        }));
        this.updateCategory$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .updateCategory(action.item, _this.toPrefix(action))
                .pipe(operators_1.map(function (category) {
                return skynet_store_kb_api_1.categoryStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.UPDATE_SUCCESS, category);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.categoryStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, new skynet_store_utilities_1.StoreManagerError(err, 'could not update category')));
            }));
        }));
        this.categorySuccess$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS), skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS), skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_SUCCESS), skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY_SUCCESS)), operators_1.map(function (action) {
            skynet_store_kb_api_1.categoryStoreManager(_this.toPrefix(action)).clearCache();
        }));
        this.deleteCategory$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.DELETE)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .deleteCategory(action.item, _this.toPrefix(action))
                .pipe(operators_1.map(function (category) {
                return skynet_store_kb_api_1.categoryStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS, category);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.categoryStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, new skynet_store_utilities_1.StoreManagerError(err, 'could not delete category')));
            }));
        }));
        // endregion
        // region fields
        this.loadFields$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ALL)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .loadFields(action.subPath, _this.toPrefix(action))
                .pipe(operators_1.map(function (fields) {
                return skynet_store_kb_api_1.fieldStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_MANY_SUCCESS, action.subPath, fields);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.fieldStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, action.subPath, new skynet_store_utilities_1.StoreManagerError(err, "could not load fields for " + action.subPath)));
            }));
        }));
        this.loadMainEntityFields$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.KbActionTypes.LoadMainEntityFieldNames), operators_1.mergeMap(function (action) {
            return _this.kbService
                .loadMainEntityFieldNames(action.mainEntityField.metaCategoryId.systemName, action.mainEntityField.systemName, action.prefix)
                .pipe(operators_1.map(function (fieldNames) {
                return new skynet_store_kb_api_1.LoadMainEntitiesSuccessAction(action.mainEntityField, fieldNames, action.prefix);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.fieldStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, '', new skynet_store_utilities_1.StoreManagerError(err, "could not load main entity fields for " + action.mainEntityField)));
            }));
        }));
        this.loadHierarchicalCategories$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.KbActionTypes.LoadHierarchicalCategories), operators_1.mergeMap(function (action) {
            return _this.kbService.loadHierarchicalCategories(action.prefix).pipe(operators_1.map(function (hierarchicalMetaCategories) {
                return new skynet_store_kb_api_1.LoadHierarchicalCategoriesSuccessAction(hierarchicalMetaCategories, action.prefix);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.fieldStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, '', new skynet_store_utilities_1.StoreManagerError(err, "could not load hierarchical Categories")));
            }));
        }));
        this.loadField$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ONE)), operators_1.mergeMap(function (action) {
            return _this.store
                .select(function (state) { return state.kb.fields[_this.toPrefix(action)]; })
                .pipe(operators_1.first(), operators_1.mergeMap(function (fields) {
                var field = skynet_store_utilities_1.notNil(fields)
                    ? fields
                        .get(action.subPath, immutable_1.List())
                        .find(function (c) {
                        return c.metaFieldId.systemName === action.id;
                    })
                    : undefined;
                if (skynet_store_utilities_1.notNil(field)) {
                    return of_1.of(skynet_store_kb_api_1.fieldStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_ONE_SUCCESS, action.subPath, field));
                }
                return _this.kbService
                    .loadField(action.subPath, action.id, _this.toPrefix(action))
                    .pipe(operators_1.map(function (metaField) {
                    return skynet_store_kb_api_1.fieldStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_ONE_SUCCESS, action.subPath, metaField);
                }), operators_1.catchError(function (err) {
                    return of_1.of(skynet_store_kb_api_1.fieldStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, action.subPath, new skynet_store_utilities_1.StoreManagerError(err, '')));
                }));
            }));
        }));
        this.createField$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.CREATE)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .createField(action.subPath, action.item, _this.toPrefix(action))
                .pipe(operators_1.switchMap(function (field) {
                return of_1.of.apply(void 0, [
                    skynet_store_kb_api_1.fieldStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS, action.subPath, field),
                    action.item.group
                        ? skynet_store_kb_api_1.groupStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS, action.subPath, group_serializer_1.createGroup(action.item.group))
                        : undefined,
                ].filter(skynet_store_utilities_1.notNil));
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.fieldStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.CREATE_FAIL, 'no sub path', new skynet_store_utilities_1.StoreManagerError(err, 'could not create fields')));
            }));
        }));
        this.deleteField$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.DELETE)), operators_1.mergeMap(function (action) {
            return _this.kbService.deleteField(action.item, _this.toPrefix(action)).pipe(operators_1.map(function (field) {
                return skynet_store_kb_api_1.fieldStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS, field.metaFieldId.metaCategoryId.systemName, field);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.fieldStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, 'no sub path', new skynet_store_utilities_1.StoreManagerError(err, 'could not delete field')));
            }));
        }));
        this.updateFields$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .updateFields(action.subPath, action.items.toList(), _this.toPrefix(action))
                .pipe(operators_1.map(function (updatedFields) {
                return skynet_store_kb_api_1.fieldStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY_SUCCESS, action.subPath, updatedFields);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.fieldStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, 'no sub path', new skynet_store_utilities_1.StoreManagerError(err, 'could not update fields')));
            }));
        }));
        this.updateField$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .updateField(action.subPath, action.item, _this.toPrefix(action))
                .pipe(operators_1.map(function (field) {
                return skynet_store_kb_api_1.fieldStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.UPDATE_SUCCESS, field.metaFieldId.metaCategoryId.systemName, field);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.fieldStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, 'no sub path', new skynet_store_utilities_1.StoreManagerError(err, 'could not update field')));
            }));
        }));
        this.fieldSuccess$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS), skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS), skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_SUCCESS), skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY_SUCCESS), skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY_SUCCESS)), operators_1.map(function (action) {
            skynet_store_kb_api_1.fieldStoreManager(_this.toPrefix(action)).clearCache();
        }));
        // endregion
        // region groups
        this.loadGroups$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ALL)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .loadGroups(action.subPath, _this.toPrefix(action))
                .pipe(operators_1.map(function (groups) {
                return skynet_store_kb_api_1.groupStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_MANY_SUCCESS, action.subPath, groups);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.groupStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, action.subPath, new skynet_store_utilities_1.StoreManagerError(err, "could not load groups for " + action.subPath)));
            }));
        }));
        this.loadGroup$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ONE)), operators_1.mergeMap(function (action) {
            // There isn't endpoint for single group, load all
            return skynet_store_kb_api_1.groupStoreManager(_this.toPrefix(action)).loadAll(_this.store, action.subPath);
        }));
        this.createGroup$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.CREATE)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .createGroup(action.item, action.subPath, _this.toPrefix(action))
                .pipe(operators_1.switchMap(function (group) {
                return of_1.of(skynet_store_kb_api_1.groupStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS, action.subPath, group));
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.groupStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.CREATE_FAIL, action.subPath, new skynet_store_utilities_1.StoreManagerError(err, 'could not create group')));
            }));
        }));
        this.deleteGroup$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.DELETE)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .deleteGroup(action.item.systemName, action.item.metaCategoryId.systemName, _this.toPrefix(action))
                .pipe(operators_1.map(function () {
                return skynet_store_kb_api_1.groupStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS, action.item.metaCategoryId.systemName, action.item);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.groupStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, action.subPath, new skynet_store_utilities_1.StoreManagerError(err, 'could not delete field')));
            }));
        }));
        this.updateGroup$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY)), operators_1.mergeMap(function (action) {
            return _this.kbService
                .updateGroups(action.items.toList(), action.subPath, _this.toPrefix(action))
                .pipe(operators_1.map(function (updatedGroups) {
                return skynet_store_kb_api_1.groupStoreManager(_this.toPrefix(action)).createAction(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY_SUCCESS, action.subPath, updatedGroups);
            }), operators_1.catchError(function (err) {
                return of_1.of(skynet_store_kb_api_1.fieldStoreManager().createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, 'no sub path', new skynet_store_utilities_1.StoreManagerError(err, 'could not update fields')));
            }));
        }));
        this.groupSuccess$ = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS), skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS), skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_SUCCESS), skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY_SUCCESS)), operators_1.map(function (action) {
            skynet_store_kb_api_1.groupStoreManager(_this.toPrefix(action)).clearCache();
        }));
        this.handleError = this.actions.pipe(effects_1.ofType(skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR), skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR), skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR)), operators_1.map(function (action) {
            KbEffects_1.clearCorrespondingCache(action.type);
            KbEffects_1.logError(action);
        }), operators_1.tap(noop_1.noop, function (e) { return logger.error(e); }));
    }
    KbEffects_1 = KbEffects;
    KbEffects.logError = function (action) {
        if (lodash_1.get(action.error, 'type') === 'StoreManagerError') {
            skynet_store_utilities_1.logStoreError(action.error, logger);
        }
        else {
            logger.error('error in kb: error => \n %o', action.error);
        }
    };
    KbEffects.clearCorrespondingCache = function (type) {
        switch (type) {
            case skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR):
                skynet_store_kb_api_1.categoryStoreManager().clearCache();
                return;
            case skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR):
                skynet_store_kb_api_1.groupStoreManager().clearCache();
                return;
            case skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR):
                skynet_store_kb_api_1.fieldStoreManager().clearCache();
                return;
            default:
                logger.error('unknown error type received from store %O', type);
        }
    };
    KbEffects.prototype.toPrefix = function (action) {
        return kb_reducers_1.extractPrefix(action.additionalData);
    };
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "loadCategories$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "loadCategory$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "createCategory$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "updateCategory$", void 0);
    __decorate([
        effects_1.Effect({ dispatch: false }),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "categorySuccess$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "deleteCategory$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "loadFields$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "loadMainEntityFields$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "loadHierarchicalCategories$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "loadField$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "createField$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "deleteField$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "updateFields$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "updateField$", void 0);
    __decorate([
        effects_1.Effect({ dispatch: false }),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "fieldSuccess$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "loadGroups$", void 0);
    __decorate([
        effects_1.Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], KbEffects.prototype, "loadGroup$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "createGroup$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "deleteGroup$", void 0);
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "updateGroup$", void 0);
    __decorate([
        effects_1.Effect({ dispatch: false }),
        __metadata("design:type", Observable_1.Observable)
    ], KbEffects.prototype, "groupSuccess$", void 0);
    __decorate([
        effects_1.Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], KbEffects.prototype, "handleError", void 0);
    KbEffects = KbEffects_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [effects_1.Actions,
            kb_service_1.KbService,
            store_1.Store])
    ], KbEffects);
    return KbEffects;
    var KbEffects_1;
}());
exports.KbEffects = KbEffects;
//# sourceMappingURL=kb.effects.js.map